import { useMutationWithRefresh } from '../useMutationWithRefresh';
import contractService from '../../services/contractService';
import { queryKeys } from '../../queryClient';

// สร้างสัญญา
export const useCreateContract = () => {
  return useMutationWithRefresh({
    mutationFn: (data: any) => contractService.createContract(data),
    invalidateKeys: [
      queryKeys.contracts.all,
      queryKeys.rentals.all, // rentals แสดงสถานะสัญญา
      queryKeys.dashboard.summary,
    ],
    successMessage: 'สร้างสัญญาสำเร็จ',
  });
};

// แก้ไขสัญญา
export const useUpdateContract = () => {
  return useMutationWithRefresh({
    mutationFn: ({ id, data }: { id: number; data: any }) => 
      contractService.updateContract(id, data),
    invalidateKeys: [
      queryKeys.contracts.all,
      queryKeys.rentals.all,
    ],
    successMessage: 'แก้ไขสัญญาสำเร็จ',
  });
};

// ลบสัญญา
export const useDeleteContract = () => {
  return useMutationWithRefresh({
    mutationFn: (id: number) => contractService.deleteContract(id),
    invalidateKeys: [
      queryKeys.contracts.all,
      queryKeys.dashboard.summary,
    ],
    successMessage: 'ลบสัญญาสำเร็จ',
  });
};
